import moment from "moment-jalaali";
class WeekGenerator {
  Calendar(Arr, Week, chunk) {
    moment.locale("en");
    const WeekDay = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    for (let j = 0; j < Arr.length; j += chunk) {
      Week.push({
        day: WeekDay[moment(Arr[j].date_time).day()],
        date_time: {
          day: Number(moment(Arr[j].date_time).format("jDD")),
          month: Number(moment(Arr[j].date_time).format("jMM")),
          year: Number(moment(Arr[j].date_time).format("jYYYY")),
        },
        times: Arr.slice(j, j + chunk),
      });
    }
  }
  Weekly(Arr, Week, chunk) {
    moment.locale("en");
    let WeekDay = ["Sat", "Sun", "Mon", "Tue", "Wed", "Thu", "Fri"];
    for (let j = 0; j < Arr.length; j += chunk) {
      Week.push({
        day: WeekDay[j / 48],
        date_time: {
          day: Number(moment(Arr[j].date_time).format("jDD")),
          month: Number(moment(Arr[j].date_time).format("jMM")),
          year: Number(moment(Arr[j].date_time).format("jYYYY")),
        },
        times: Arr.slice(j, j + chunk),
      });
    }
  }
}
export default new WeekGenerator();
